export const VEHICLE_KEYS = {
    BODY: 'frameStyleIds',
    DRIVE: 'driveTrainIds',
    ENGINE: 'engineIds',
    EXTERNAL_COLOR: 'exteriorColorIds',
    FUEL: 'fuelIds',
    INTERNAL_COLOR: 'interiorColorIds',
    MAKE: 'makeIds',
    MODEL: 'modelIds',
    TEXT: 'textSearch',
    TRIM: 'trimIds',
    TRANSMISSION: 'transmissionIds',
    YEAR: 'years',
    MIN_SALE_PRICE: 'minSalePrice',
    MAX_SALE_PRICE: 'maxSalePrice',
    MIN_ODOMETER: 'minOdometer',
    MAX_ODOMETER: 'maxOdometer',
};

export const CATEGORY_USED = 'used';
export const CATEGORY_USED_NOTDEMO = 'used-notdemo';
export const CATEGORY_NEW = 'new';
export const CATEGORY_NEW_NOTDEMO = 'new-notdemo';
export const CATEGORY_CATALOG = 'catalog';

export const CATEGORIES = [CATEGORY_USED, CATEGORY_NEW, CATEGORY_CATALOG];

export const KEY_ENTER = 13;

export const PAGE_SIZE = 12;

/** ****************
 * FILTERS
 ***************** */
export const FILTER_KEYS = {
    BODY: 'body',
    DRIVE: 'drive',
    ENGINE: 'engine',
    EXTERNAL_COLOR: 'externalColor',
    FUEL: 'fuel',
    INTERNAL_COLOR: 'internalColor',
    MAKE: 'make',
    MODEL: 'model',
    TRIM: 'trim',
    TRANSMISSION: 'transmission',
    YEAR: 'year',
};

export const MIN_ODOMETER = 0;
export const MAX_ODOMETER = 400000;
export const MIN_PRICE = 0;
export const MAX_PRICE = 400000;

export const SORT_VALUE = {
    DATE_ASC: 'dateAsc',
    DATE_DESC: 'dateDesc',
    PRICE_ASC: 'priceAsc',
    PRICE_DESC: 'priceDesc',
    ODOMETER_ASC: 'odometerAsc',
    ODOMETER_DESC: 'odometerDesc',
};

export const SORT_TYPE = {
    DATE: 'DATE_ENTRY',
    SALE_PRICE: 'SALE_PRICE',
    PRICE: 'PRICE',
    ODOMETER: 'ODOMETER',
    FEATURED: 'FEATURED',
};

export const SORT_DIR = {
    ASC: 'ASC',
    DESC: 'DESC',
};

export const SORT_DATA = [
    {
        VALUE: SORT_VALUE.DATE_ASC,
        DIR: SORT_DIR.ASC,
        TYPE: SORT_TYPE.DATE,
    },
    {
        VALUE: SORT_VALUE.DATE_DESC,
        DIR: SORT_DIR.DESC,
        TYPE: SORT_TYPE.DATE,
    },
    {
        VALUE: SORT_VALUE.PRICE_ASC,
        DIR: SORT_DIR.ASC,
        TYPE: SORT_TYPE.PRICE,
    },
    {
        VALUE: SORT_VALUE.PRICE_DESC,
        DIR: SORT_DIR.DESC,
        TYPE: SORT_TYPE.PRICE,
    },
    {
        VALUE: SORT_VALUE.ODOMETER_ASC,
        DIR: SORT_DIR.ASC,
        TYPE: SORT_TYPE.ODOMETER,
    },
    {
        VALUE: SORT_VALUE.ODOMETER_DESC,
        DIR: SORT_DIR.DESC,
        TYPE: SORT_TYPE.ODOMETER,
    },
];

/** ****************
 * PAYMENT
 ***************** */
export const KEY_CASHDOWN = 'cashDown';
export const KEY_FREQUENCY = 'paymentFrequency';
export const KEY_LIEN = 'lien';
export const KEY_KMPLAN = 'kmPerYearPlan';
export const KEY_TERM = 'term';
export const KEY_TRADEIN = 'tradeIn';

export const PURCHASE_METHOD_CASH = 'cash';
export const PURCHASE_METHOD_FINANCE = 'finance';
export const PURCHASE_METHOD_LEASE = 'lease';
export const PURCHASE_METHOD_DEFAULT = PURCHASE_METHOD_CASH;

export const PURCHASE_METHODS = [PURCHASE_METHOD_CASH, PURCHASE_METHOD_FINANCE, PURCHASE_METHOD_LEASE];
